import { SettingOutlined, HomeOutlined, FileOutlined, LogoutOutlined } from '@ant-design/icons';
import type { Route } from '@ant-design/pro-layout/lib/typings';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useBasicMenu = () => {
    const { t } = useTranslation('common');

    return useMemo(
        (): Route => ({
            routes: [
                {
                    label: t('common:leftMenu.home'),
                    href: '/',
                    key: 'home',
                    icon: <HomeOutlined />,
                },
                {
                    label: t('common:leftMenu.leads'),
                    href: '/leads',
                    key: 'leads',
                    icon: <SettingOutlined />,
                },
                {
                    label: t('common:leftMenu.applications'),
                    href: '/applications',
                    key: 'applications',
                    icon: <FileOutlined />,
                },
                {
                    label: t('common:leftMenu.events'),
                    href: '/events',
                    key: 'events',
                    icon: <FileOutlined />,
                },
                {
                    label: t('common:leftMenu.signout'),
                    href: '/singout',
                    key: 'signout',
                    icon: <LogoutOutlined />,
                },
            ],
        }),
        [t]
    );
};

export default useBasicMenu;
